import styled from 'styled-components'

import { fonts, mediaQueries, palette } from '../../styles/variables'

export const Wrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  padding: '20px',
  border: `1px solid ${palette.lightGray50}`,
  width: '100%',
  ':first-child': {
    gridColumn: '1 / 2',
    gridRow: 'span 2',
  },
  [mediaQueries.smallDesktop]: {
    ':first-child': {
      gridColumn: '1 / 3',
      gridRow: 'span 2',
    },
  },
})

export const Subtitle = styled.span({
  fontSize: '12px',
  fontFamily: fonts.primary,
  color: palette.darkGray50,
})

export const TitleWrapper = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'baseline',
  marginBottom: '24px',
})

export const Divider = styled.hr(({ vertical, isPDFScreenshot }) => ({
  border: `1px solid ${palette.lightGray50}`,
  height: vertical ? '100%' : 0,
  width: vertical ? 0 : '100%',
  [mediaQueries.mobile]: {
    width: '100%',
    height: 0,
  },
  ...(isPDFScreenshot && {
    [mediaQueries.tablet]: {
      height: '100%',
      width: 0,
    },
  }),
}))

export const TooltipContainer = styled.div({
  fontSize: '14px',
  lineHeight: '16px',
  fontFamily: fonts.primaryBold,
  marginBottom: '12px',
})

export const CardInformation = styled.div({
  display: 'flex',
  flexDirection: 'column',
  marginTop: '12px',
  [mediaQueries.mobile]: {
    alignItems: 'center',
    marginTop: 0,
  },
})

export const ValueAndEvaluation = styled.div({
  display: 'flex',
  fontFamily: fonts.primaryBold,
  fontSize: '24px',
  marginBottom: '10px',
  [mediaQueries.mobile]: {
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
  },
})

export const BoxContent = styled.div({
  display: 'flex',
  gap: '24px',
  [mediaQueries.mobile]: {
    flexDirection: 'column',
  },
})

export const LeftSide = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  [mediaQueries.mobile]: {
    gap: '24px',
  },
})

export const RightSide = styled.div({
  width: '100%',
})
